import {content} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from 'components/grid-dx/types';

function useDeleteContent() {
  const deleteContent = useDelete(content);
  return (deletingOptions: DeletingOptions) => deleteContent(deletingOptions);
}

export default useDeleteContent;
